// extracted by mini-css-extract-plugin
export default {"wrapper":"BalanceAlarmDetails_wrapper__P+s3G","col":"BalanceAlarmDetails_col__d6V1b"};